import gsap from 'gsap';

export default function initToggleTabs() {
  const classActive = 'is-active';
  const instances = [];
  let resizeTimer;

  document.querySelectorAll('.toggle-tabs').forEach(tabs => {
    const tabItems = tabs.querySelectorAll('.tab');
    if (!tabItems.length) return;

    const indicator = document.createElement('span');
    indicator.className = 'tab-indicator';
    tabs.prepend(indicator);

    let activeTab = tabs.querySelector(`.tab.${classActive}`) || tabItems[0];

    function moveIndicator(tab, animate) {
      const fn = animate ? gsap.to : gsap.set;
      fn(indicator, { x: tab.offsetLeft, width: tab.offsetWidth });
    }

    activeTab.classList.add(classActive);
    moveIndicator(activeTab, false);

    tabItems.forEach(tab => {
      tab.addEventListener('click', () => {
        tabItems.forEach(t => t.classList.remove(classActive));
        tab.classList.add(classActive);
        activeTab = tab;
        moveIndicator(tab, true);
      });
    });

    instances.push(() => moveIndicator(activeTab, false));
  });

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => instances.forEach(update => update()), 100);
  });
}
